import { tradeResponseState } from './tradeResponse.state';
import { tradeResponseActions } from './tradeResponse.actions';
import { tradeResponseGetters } from './tradeResponse.getters';
import { tradeResponseMutations } from './tradeResponse.mutations';

export default {
  state: tradeResponseState,
  actions: tradeResponseActions,
  getters: tradeResponseGetters,
  mutations: tradeResponseMutations,
};
